import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { UserCollectionQuery, UserCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root' })
@QueryHandlerFor(UserCollectionQuery)
@Wrapper(UserCollectionQueryHandlerBase)
export class UserCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
